import { Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
export const AmlFieldLabel = ({ children, tag = 'span' }) => {
    const { tokens } = useContext(ThemeContext).theme;
    return (React.createElement(Text, { style: {
            fontSize: tokens.text.size.xsmall,
            fontWeight: tokens.text.weight.bold,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: tokens.colors.gray300
        }, tag: tag }, children));
};
